<template>
  <div class="max-w-lg mx-auto">
    <div class="p-8 stack-lg" v-if="forgotPassword">
      <p>{{ $t('login.forgot_password_message')}}</p>
      <input-text
        :label="$t('general.email')"
        required
        :validations="[{ validation: 'email' }]"
        @update-value="updateForm('email', $event)"
      />
      <div class="text-right">
        <wd-button
          :disabled="!formData.email"
          :sending="sending"
          @input="submit(forgotPasswordFormOptions)"
        >{{ $t("general.send") }}</wd-button>
      </div>
      <div class="text-left">
        <wd-button black @input="forgotPassword = false">{{ $t("general.cancel") }}</wd-button>
      </div>
    </div>
    <div v-else>
      <form class="stack" novalidate @submit.prevent="submit(formOptions)" v-if="logged === false">
        <input-text
          :label="$t('general.username')"
          required
          @update-value="updateForm('username', $event)"
        />
        <input-text
          type="password"
          :label="$t('general.password')"
          required
          @update-value="updateForm('password', $event)"
        />
        <div class="text-right">
          <wd-button :sending="sending">{{ $t("login.login_action") }}</wd-button>
        </div>
        <div class="text-gray-700 text-sm leading-snug mt-2">
          <p class="font-light">{{ $t("login.no_account") }}</p>
          <p class="text-primary-500">
            <router-link to="/register">
              {{
              $t("login.register_now")
              }}
            </router-link>
          </p>
          <p
            class="mt-2 italic text-gray-600 cursor-pointer hover:text-gray-900"
            @click="forgotPassword = true"
          >{{ $t('login.forgot_password') }}</p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
const FormMixin = require("@/mixins/FormMixin").default;

export default {
  name: "LoginForm",
  mixins: [FormMixin],
  data() {
    return {
      forgotPassword: false
    };
  },
  computed: {
    logged: function() {
      return this.$store.getters["auth/logged"];
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    }
  },
  async created() {
    this.formOptions = {
      custom: true,
      type: "auth",
      call: "login",
      action: () => {
        this.goTo("/");
      }
    };
    this.forgotPasswordFormOptions = {
      custom: true,
      async: false,
      type: "auth",
      call: "forgot",
      action: () => {
        this.forgotPassword = false;
      }
    };
  }
};
</script>
